<div class="grid">
	<div class="col-12 py-0">
		<p-accordion [activeIndex]="activeIndex">
			<p-accordionTab *ngFor="let privacyNote of privacyNoteList">
				<ng-template pTemplate="header">
					<div class="flex align-items-center w-full"
						[class]="!onExtendedMobile() ? 'flex-row justify-content-between' : 'flex-column justify-content-center'">
						<div class="font-bold" [class]="!onExtendedMobile() ? '' : 'pb-1'">{{privacyNote.ReleaseVersion}}</div>
					</div>
				</ng-template>
				<p-panel>
					<div [innerHTML]="privacyNote.Text">
					</div>
				</p-panel>
			</p-accordionTab>
		</p-accordion>
	</div>
	<div class="col-12 pb-0">
		<div class="flex justify-content-center">
			<p-button *ngIf="limitedList" label="{{ 'EXPAND_ALL' | translate }}" icon="pi pi-plus" text severity="primary" (onClick)="expandAll()" />
			<p-button *ngIf="!limitedList" label="{{ 'COLLAPSE_ALL' | translate }}" icon="pi pi-minus" text severity="primary" (onClick)="collapseAll()" />
		</div>
	</div>
</div>

<div class="grid mt-3 mb-1 mx-1 flex justify-content-center align-items-center">
	<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
		class="p-button-secondary text-xl font-normal" [ngClass]="dynamicButtonWidth()">
	</button>
</div>